import React from 'react';
import SubContext from '../../subs/SubContext';
import DisplayDashboard from './DisplayDashboard';
import DashboardContext from '../DashboardContext';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  noDash: {
    position: 'absolute',
    left: '20px',
  },
}));

const DashboardCheck = () => {
  const ctx = React.useContext(SubContext);
  const dashCtx = React.useContext(DashboardContext);
  const classes = useStyles();

  if (ctx.selectedSub && dashCtx.dashboards.length === 0) {
    return <Typography className={classes.noDash}>No Dashboards</Typography>;
  }

  return <DisplayDashboard />;
};

export default DashboardCheck;
